import type { ProductCategory, ServiceCategory } from '@/libs/interfaces'

import { MOCK_ORG_ID } from './seed'

export const MOCK_SERVICE_CATEGORY_ID_MAINTENANCE = 'service-category-1'
export const MOCK_SERVICE_CATEGORY_ID_TIRES = 'service-category-2'
export const MOCK_SERVICE_CATEGORY_ID_BRAKES = 'service-category-3'
export const MOCK_SERVICE_CATEGORY_ID_DETAILING = 'service-category-4'
export const MOCK_SERVICE_CATEGORY_ID_INSPECTION = 'service-category-5'

export const MOCK_PRODUCT_CATEGORY_ID_FLUIDS = 'product-category-1'
export const MOCK_PRODUCT_CATEGORY_ID_FILTERS = 'product-category-2'
export const MOCK_PRODUCT_CATEGORY_ID_BRAKE_PARTS = 'product-category-3'
export const MOCK_PRODUCT_CATEGORY_ID_TIRES = 'product-category-4'
export const MOCK_PRODUCT_CATEGORY_ID_ACCESSORIES = 'product-category-5'

const isoTimestamp = '2025-01-10T08:00:00Z'

export const mockServiceCategories: ServiceCategory[] = [
  {
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_MAINTENANCE,
    orgID: MOCK_ORG_ID,
    serviceCategoryName: 'Maintenance',
    serviceCategoryDescription: 'Routine service and maintenance work',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_TIRES,
    orgID: MOCK_ORG_ID,
    serviceCategoryName: 'Tires',
    serviceCategoryDescription: 'Tire fitting, rotation and balancing',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_BRAKES,
    orgID: MOCK_ORG_ID,
    serviceCategoryName: 'Brakes',
    serviceCategoryDescription: 'Brake inspection and replacement',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_DETAILING,
    orgID: MOCK_ORG_ID,
    serviceCategoryName: 'Detailing',
    serviceCategoryDescription: 'Cleaning and cosmetic care',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    serviceCategoryID: MOCK_SERVICE_CATEGORY_ID_INSPECTION,
    orgID: MOCK_ORG_ID,
    serviceCategoryName: 'Inspection',
    serviceCategoryDescription: 'Safety and diagnostic inspections',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
]

export const mockProductCategories: ProductCategory[] = [
  {
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_FLUIDS,
    orgID: MOCK_ORG_ID,
    productCategoryName: 'Fluids',
    productCategoryDescription: 'Oils and other fluids',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_FILTERS,
    orgID: MOCK_ORG_ID,
    productCategoryName: 'Filters',
    productCategoryDescription: 'Oil, air and cabin filters',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_BRAKE_PARTS,
    orgID: MOCK_ORG_ID,
    productCategoryName: 'Brake Parts',
    productCategoryDescription: 'Pads, discs and brake fluid',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_TIRES,
    orgID: MOCK_ORG_ID,
    productCategoryName: 'Tires',
    productCategoryDescription: 'Tires and wheel accessories',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
  {
    productCategoryID: MOCK_PRODUCT_CATEGORY_ID_ACCESSORIES,
    orgID: MOCK_ORG_ID,
    productCategoryName: 'Accessories',
    productCategoryDescription: 'Miscellaneous workshop accessories',
    createdAt: isoTimestamp,
    updatedAt: isoTimestamp,
  },
]
